import React, { useRef, useState } from "react";
import { TableComponent } from "../table/TableComponent";
import { Space } from "../space/Space";
import { useAppSelector } from "../../app/store/hooks";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import { VerticalLine } from "../vertical-line/VerticalLine";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import Row from "@amzn/meridian/row";
import { useNavigate } from "react-router-dom";
import { StatusEnum } from "../../endpoints/getArtifacts";

export const AssessmentsTable: React.FC = () => {
    const currentTable = "open-assessments";
    const { alias } = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();
    const [propertyType, setPropertyType] = useState("my-properties");
    const assessmentTableRef = useRef(null);

    return (
        <React.Fragment>
            <Row widths={["fill", "fit"]}>
                <Text type={"h400"}>Open property assessments</Text>
                <Button size="small" onClick={() => navigate("/create-property")} type="tertiary">
                    Create property
                </Button>

                <Button size="small" onClick={() => navigate("/upload-comps")} type="tertiary">
                    Upload Comps
                </Button>

                <Button
                    size="small"
                    onClick={() => assessmentTableRef.current.exportTableData()}
                    type="tertiary"
                >
                    Export
                </Button>
                <VerticalLine height={30} />
                <ButtonGroup size="small" value={propertyType} onChange={setPropertyType}>
                    <ButtonOption value="my-properties">My properties</ButtonOption>
                    <ButtonOption value="all-properties">All properties</ButtonOption>
                </ButtonGroup>
            </Row>
            <Space size={"xs"} />
            <Box backgroundColor={"principal"} spacingInset={"400"}>
                <TableComponent
                    onSearch={false}
                    tableName={currentTable}
                    hideTableHeader={true}
                    inputPageSize={"5"}
                    tableUseCase={"GET_APPEALS"}
                    tableRef={assessmentTableRef}
                    tableQueryParams={{
                        status: [
                            StatusEnum.NEW,
                            StatusEnum.PREPARING,
                            StatusEnum.UNDER_APPEAL,
                            StatusEnum.EDITING,
                        ],
                        ...(propertyType === "my-properties" ? { assignedTo: alias } : null),
                    }}
                />
            </Box>
        </React.Fragment>
    );
};
